import React, { FunctionComponent } from 'react';
import { HashRouter, Switch, Route } from 'react-router-dom';

import { Roles } from '@dinnisoft/esteio-gestao-common';
import { useAuth } from 'contexts/auth';
import Animais from 'views/Animais';
import Dashboard from 'views/Dashboard';
import Fazendas from 'views/Fazendas';
import Layout from 'views/Layout';
import Lotes from 'views/Lotes';
import NotFound from 'views/NotFound';
import Perfil from 'views/Perfil';
import Profile from 'views/Profile';

interface RouteWithLayoutProps {
  title: string;
  path: string;
  exact?: boolean;
  contentComponent: string | FunctionComponent<any>;
}

const RouteWithLayout = ({
  title,
  path,
  contentComponent,
  exact = false,
  ...rest
}: RouteWithLayoutProps) => (
  <Route
    path={path}
    exact={exact}
    component={() => <Layout title={title} content={React.createElement(contentComponent)} />}
    {...rest}
  />
);

const AdminRoutes = () => (
  <>
    <RouteWithLayout title="Fazendas" path="/fazendas" contentComponent={Fazendas} />
    <RouteWithLayout title="Animal" path="/animal" contentComponent={Animais} />
  </>
);

const CentralRoutes = () => (
  <>
    <RouteWithLayout title="Central" path="/" contentComponent={Dashboard} exact />
    <RouteWithLayout title="Animais" path="/animais" contentComponent={Animais} />
    <RouteWithLayout title="Lotes" path="/lotes" contentComponent={Lotes} />
    <RouteWithLayout title="Editar Dados" path="/profile" contentComponent={Profile} />
  </>
);

// const ConsultorRoutes = () => (
//   <>
//     <RouteWithLayout title="Consultor" path="/" contentComponent={Dashboard} exact />
//     <RouteWithLayout title="Animais" path="/animais" contentComponent={Animais} />
//     <RouteWithLayout title="Lotes" path="/lotes" contentComponent={Lotes} />
//   </>
// );

// const ProdutorRoutes = () => (
//   <>
//     <RouteWithLayout title="Produtor" path="/" contentComponent={Dashboard} exact />
//     <RouteWithLayout title="Animais" path="/animais" contentComponent={Animais} />
//     <RouteWithLayout title="Lotes" path="/lotes" contentComponent={Lotes} />
//   </>
// );

const AuthenticatedRoutes = () => {
  const context = useAuth();

  return (
    <HashRouter>
      <Switch>
        {context.selectedRole === Roles.central && <CentralRoutes />}
        {/* {context.selectedRole === Roles.consultor && <ConsultorRoutes />}
        {context.selectedRole === Roles.produtor && <ProdutorRoutes />} */}
        {context.selectedRole === 0 && <Route path="/" component={Perfil} exact />}

        <RouteWithLayout title="Editar Dados" path="/profile" contentComponent={Profile} />

        {context.selectedRole === Roles.admin && <AdminRoutes />}

        <Route path="*" component={NotFound} />
      </Switch>
    </HashRouter>
  );
};

export default AuthenticatedRoutes;
